import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, HostBinding } from '@angular/core';

@Component({
  selector: 'password-strength-meter',
  templateUrl: './password-strength-meter-updated.component.html',
  styleUrls: ['./password-strength-meter.component.scss'],
})
export class PasswordStrengthMeterComponent implements OnChanges {
  @Input() password!: string;

  @Input() minPasswordLength = 8;

  @Input() enableFeedback = false;

  @Input() colors: string[] = [];

  @Input() numberOfProgressBarItems = 5;

  @Input() passwordPolicy: any;
 
  @Output() strengthChange = new EventEmitter<number>();

  @HostBinding('class') baseClass = 'psm';

  feedback: { suggestions: string[]; warning: string } | null = null;

  passwordStrength: number | null = null;

  private prevPasswordStrength: number | null = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['password']) {
      this.calculatePasswordStrength();
    }
  }

  /**
   * Calculate password strength if changed then emit
   */
  private calculatePasswordStrength() {
    // TODO validation logic optimization
    if (!this.password) {
      this.passwordStrength = null;
      this.feedback = null;
    }
    // else if (this.password && this.password.length < this.minPasswordLength) {
    //   this.passwordStrength = 0;
    //   this.feedback = null;
    // }
    else {
      if (this.enableFeedback) {
        const result = this.scoreWithFeedback(this.password);
        this.passwordStrength = result.score;
        this.feedback = result.feedback;
      } else {
        this.passwordStrength = this.score(this.password);
        this.feedback = null;
      }
    }

    // Only emit the passwordStrength if it changed
    if (this.prevPasswordStrength !== this.passwordStrength) {
      this.strengthChange.emit(this.passwordStrength!);
      this.prevPasswordStrength = this.passwordStrength;
    }
  }

  /**
   *  this will return the password strength score in number
   *  0 - too guessable
   *  1 - very guessable
   *  2 - somewhat guessable
   *  3 - safely unguessable
   *  4 - very unguessable
   *
   *  @param password - Password
   */
  score(password: string): number {
    const result = this.checkPasswordStrength(password);
    return result.score;
  }

  /**
   * this will return the password strength score with feedback messages
   * return type { score: number; feedback: { suggestions: string[]; warning: string } }
   *
   * @param password - Password
   */
  scoreWithFeedback(password: string): {
    score: number;
    feedback: { suggestions: string[]; warning: string };
  } {
    const result = this.checkPasswordStrength(password);
    return { score: result.score, feedback: result.feedback };
  }

  /**
   * this will return the password strength object
   * return type { score: number; feedback: { suggestions: string[]; warning: string } }
   *
   * @param password - Password
   */
  checkPasswordStrength(password: string) { 
    // Initialize variables
    let score = -1;
    let warning = '';
    const suggestions: Array<string> = [];
    // debugger;
    // Check password length
    // if (this.passwordPolicy?.Length > 0) {
    if (password.length < this.passwordPolicy.Length) {
      suggestions.push(`The password is at least ${this.passwordPolicy.Length} characters long`);
    } else {
      score += 1;
    }
    // }

    // Check for mixed case
    if (this.passwordPolicy?.IsLowerCase) {
      if (password.match(/[a-z]/)) {
        score += 1;
      } else {
        suggestions.push('one lowercase letter');
      }
    }

    // Check for mixed case
    if (this.passwordPolicy?.IsUpperCase) {
      if (password.match(/[A-Z]/)) {
        score += 1;
      } else {
        suggestions.push('one uppercase letter');
      }
    }

    if (this.passwordPolicy?.IsDigit) {
      // Check for numbers
      if (password.match(/\d/)) {
        score += 1;
      } else {
        suggestions.push('one digit');
      }
    }

    // Check for special characters
    if (this.passwordPolicy?.IsSpecialCharacter) {
      if (password.match(/[^a-zA-Z\d]/)) {
        score += 1;
      } else {
        suggestions.push('a special character');
      }
    }

    // Generate warning
    if (score == 0) {
      warning += 'Very weak';
    } else if (score === 1) {
      warning += 'Weak';
    } else if (score === 2) {
      warning += 'Medium';
    } else if (score === 3) {
      warning += 'Strong';
    }  else if (score === 4) {
      warning += 'Extremely Strong';
    } else {
      warning += 'Extremely Strong';
    }
    // if (score < 1) {
    //   warning += 'Very weak';
    // } else if (score === this.numberOfProgressBarItems - 2) {
    //   warning += 'Medium';
    // } else if (score === this.numberOfProgressBarItems - 1) {
    //   warning += 'Extremely Strong';
    // } else {
    //   warning += 'Strong';
    // }

    return { score, feedback: { suggestions, warning } };
  }
}
